import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true); // Open by default
  const location = useLocation(); // Get current route

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsOpen(false); // Close sidebar on smaller screens
      } else {
        setIsOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const files = [
    { name: "ZEUSS_whitepaper", url: "/images/ZEUSS_whitepaper.pdf" },
  ];
  const downloadFiles = () => {
    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <>
      <button className="toggle-button" onClick={toggleSidebar}>
        ☰
      </button>
      <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
        <div className="sidebar-content">
          <div className="logo text-center pt-3">
            <Link to="/">
              <img
                src="/images/logo.png"
                style={{ maxWidth: "150px" }}
                className="pb-2"
                alt="logo"
              />
            </Link>
            <img src="/images/divide-logo.png" alt="divide" />
          </div>
          <ul>
            <li className={location.pathname === "/buy" ? "active" : ""}>
              <Link to="/buy">
                <img
                  src="/images/homeadminwhite.png"
                  className="white"
                  alt=""
                />
                <img
                  src="/images/homeadminblack.png"
                  className="black"
                  alt=""
                />
                Dashboard
              </Link>
            </li>
            <li
              className={
                location.pathname === "/dashboard-staking" ? "active" : ""
              }
            >
              <Link to="/dashboard-staking">
                <img src="/images/homestakblack.png" className="black" alt="" />
                <img src="/images/homestakwhite.png" className="white" alt="" />
                Staking
              </Link>
            </li>
            {/* <li>
              <Link to="">
                <img src="/images/hometerm.png" alt="" />
                Term & Condition
              </Link>
            </li> */}
            <li>
              <Link onClick={downloadFiles}>
                <img
                  src="/images/homewhite.png"
                  className="d-inline-block"
                  alt=""
                />
                Whitepaper
              </Link>
            </li>
          </ul>
          <div className="documentation">
            <img src="/images/help.png" alt="" />
            <h5 className="pt-3">Need help?</h5>
            <p className="pb-3 pt-2">Please check our docs</p>
            <Link to="mailto:support@zeuss.one">Contact us</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
